<!--
  AriaAnnouncer — región aria-live global (Story 2.9 / 2.10). Sin UI.
  Reemplaza a AriaAnnouncerLegacy.
-->

<script setup>
import { useAriaAnnouncer } from '@/composables/useAriaAnnouncer.js';

defineOptions({ name: 'DsAriaAnnouncer' });

const { message } = useAriaAnnouncer();
</script>

<template>
  <div
    aria-live="polite"
    aria-atomic="true"
    class="visually-hidden"
  >
    {{ message }}
  </div>
</template>
